import { ApplicationState } from '@/redux/store'
import { put, select } from 'redux-saga/effects'
import { deleteQuickReplyAction, fetchRepliesByCompanyAction } from '../../handles'
import { deleteReply } from '../_http/reply'

export function* deleteQuickReplySaga(action: ReturnType<typeof deleteQuickReplyAction.request>) {
  const { quickReplyId } = action.payload
  try {
    yield deleteReply(quickReplyId)
    yield put(deleteQuickReplyAction.success())

    const companyState = yield select((state: ApplicationState) => state.companyReducer)

    yield put(fetchRepliesByCompanyAction.request({ companyId: companyState?.selectedCompany, operatorId: null }))
  } catch (error) {
    yield put(deleteQuickReplyAction.failure())
  }
}
